import { useContext } from "react";

import { useAdminAirlineApi } from "../../../../airline/common/api/useAdminAirlineApi";
import { SystemPlatformDetailsContext } from "../../context/SystemPlatformDetailsContext";
import { EditBuzzIdsFormInputs } from "./EditBuzzIdsForm";

export const useEditBuzzIdsForm = (systemId: string) => {
    const { updateBuzzIds } = useAdminAirlineApi();

    const { systemPlatformDetailsItem, updateBuzzIds: updateBuzzIdsItem } = useContext(SystemPlatformDetailsContext);

    const itemToEdit = systemPlatformDetailsItem.buzzIds;

    const editBuzzIds = async ({ buzzIds }: EditBuzzIdsFormInputs) => {
        const buzzIdValues = buzzIds.map((buzzId) => buzzId.value).filter((value) => value);

        await updateBuzzIds({
            airlineId: systemPlatformDetailsItem.airline.id,
            systemId,
            buzzIds: buzzIdValues
        });

        updateBuzzIdsItem(buzzIdValues);
    };

    return {
        itemToEdit,
        editBuzzIds
    };
};
